import { IFooter } from '../../queries/fragments/blockFooter';
import { IChinaFooter } from '../../queries/fragments/chinaFooterSlice';
import { ILibraryServiceType } from '../../queries/fragments/libraryServiceType';
import { IMeetingPlaceLinkToAnyPage } from '../../queries/fragments/meetingPlaceLinkToAnyPage';
import { IMeetingPlacePageEditorial } from '../../queries/fragments/meetingPlacePageEditorial';
import { IMeetingPlacePageEventItem } from '../../queries/fragments/meetingPlacePageEventItem';
import { IMeetingPlacePageLeisurePackageOfferItem } from '../../queries/fragments/meetingPlacePageLeisurePackageOfferItem';
import { IMeetingPlacePageNewsItem } from '../../queries/fragments/meetingPlacePageNewsItem';
import { TOccationTypes } from '../../queries/fragments/meetingPlacePageOccations';
import { IMeetingPlacePageOfferItem } from '../../queries/fragments/meetingPlacePageOfferItem';
import { IMeetingPlacePageServiceItem } from '../../queries/fragments/meetingPlacePageServiceItem';
import { IMeetingPlacePageTenantEntertainmentItem } from '../../queries/fragments/meetingPlacePageTenantEntertainmentItem';
import { IMeetingPlacePageTenantFoodBevItem } from '../../queries/fragments/meetingPlacePageTenantFoodBevItem';
import { TTenantTypes } from '../../queries/fragments/meetingPlacePageTenantList';
import { IMeetingPlacePageTenantShopItem } from '../../queries/fragments/meetingPlacePageTenantShopItem';
import {
  EditorialCard,
  LeisurePackageOfferCard,
  ListCard,
  OccationEventCard,
  OccationNewsCard,
  OccationOfferCard,
  ServiceCard,
  ServiceSubCategoryCard,
  SubTenantCard,
  TenantCard,
} from './interfaces/list-card.interface';

export const pageIsService = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem
    | ILibraryServiceType,
): page is IMeetingPlacePageServiceItem => {
  return (
    (page as IMeetingPlacePageServiceItem).__typename ===
    'ContentfulMeetingPlacePageServiceItem'
  );
};

export const pageIsEvent = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageEventItem => {
  return (
    (page as IMeetingPlacePageEventItem).__typename ===
    'ContentfulMeetingPlacePageEventItem'
  );
};

export const pageIsNewsItem = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageNewsItem => {
  return (
    (page as IMeetingPlacePageNewsItem).__typename ===
    'ContentfulMeetingPlacePageNewsItem'
  );
};

export const pageIsOffer = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageOfferItem => {
  return (
    (page as IMeetingPlacePageOfferItem).__typename ===
    'ContentfulMeetingPlacePageOfferItem'
  );
};

export const pageIsTenantShop = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantShopItem => {
  return (
    (page as IMeetingPlacePageTenantShopItem).__typename ===
    'ContentfulMeetingPlacePageTenantShopItem'
  );
};

export const pageIsTenantEntertainment = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantEntertainmentItem => {
  return (
    (page as IMeetingPlacePageTenantEntertainmentItem).__typename ===
    'ContentfulMeetingPlacePageTenantEntertainmentItem'
  );
};

export const pageIsTenantFoodBeverage = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantFoodBevItem => {
  return (
    (page as IMeetingPlacePageTenantFoodBevItem).__typename ===
    'ContentfulMeetingPlacePageTenantFoodBevItem'
  );
};

export const pageIsEditorial = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageEditorial => {
  return (
    (page as IMeetingPlacePageEditorial).__typename ===
    'ContentfulMeetingPlacePageEditorial'
  );
};

export const pageIsLeisurePackageOffer = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageLeisurePackageOfferItem => {
  return (
    (page as IMeetingPlacePageLeisurePackageOfferItem).__typename ===
    'ContentfulMeetingPlacePageLeisurePackageOfferItem'
  );
};

export const pageIsServiceSubCategory = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem
    | ILibraryServiceType,
) => {
  return (
    (page as ILibraryServiceType).__typename === 'ContentfulLibraryServiceType'
  );
};

export const cardIsService = (card: ListCard): card is ServiceCard => {
  return (card as ServiceCard).cardType === 'service';
};

export const cardIsServiceSubCategory = (
  card: ListCard,
): card is ServiceSubCategoryCard => {
  return (card as ServiceSubCategoryCard).cardType === 'service_sub_category';
};

export const cardIsTenant = (card: ListCard): card is TenantCard => {
  return (card as TenantCard).cardType === 'tenant';
};

export const cardIsSubTenant = (card: ListCard): card is TenantCard => {
  return (card as SubTenantCard).cardType === 'subTenant';
};

export const cardIsNewsItem = (card: ListCard): card is OccationNewsCard => {
  return (card as OccationNewsCard).cardType === 'news';
};

export const cardIsOffer = (card: ListCard): card is OccationOfferCard => {
  return (card as OccationOfferCard).cardType === 'offer';
};

export const cardIsEvent = (card: ListCard): card is OccationEventCard => {
  return (card as OccationEventCard).cardType === 'event';
};

export const cardIsEditorial = (card: ListCard): card is EditorialCard => {
  return (card as EditorialCard).cardType === 'editorial';
};

export const cardIsLeisurePackageOffer = (
  card: ListCard,
): card is LeisurePackageOfferCard => {
  return (card as LeisurePackageOfferCard).cardType === 'leisurePackageOffer';
};

export const linkHasSVG = (
  page: string | IMeetingPlaceLinkToAnyPage,
): page is IMeetingPlaceLinkToAnyPage => {
  return typeof page !== 'string' && !!page.linkSvg;
};

export const footerIsMeetingPlace = (
  footer: IFooter | IChinaFooter,
): footer is IFooter => {
  return (footer as IFooter)?.blocktype === 'ContentfulBlockFooter';
};
